import styled, { css }  from 'styled-components';
import { Slider } from 'antd';
import { SvgIcon } from '../svg-icon';


export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  
  margin-bottom: 10px;
  
  ${({disabled}: {disabled: boolean}) => disabled && css`
		cursor: not-allowed;
	`}
`;

export const StyledSlider = styled(Slider)`
  margin: 14px 14px 10px !important;
  
  min-width: 150px;
  
  .ant-slider-dot {
    display: none;
  } 
  
  .ant-slider-track,
  .ant-slider-rail {
    height: 2px;
    background-color: ${({theme}) => theme.colors.backgroundPutty} !important;
  }
  
  .ant-slider-rail {
    border-radius: 0;
  }
  
  &.ant-slider-disabled {
  	.ant-slider-track,
  	.ant-slider-rail {
			background-color: ${({theme}) => theme.colors.silver} !important;
  	}
  }

  .ant-slider-handle {
    width: 24px;
    height: 24px;
    
    margin-top: -10px;
    // margin-left: -12px;

    border-color: ${({theme}) => theme.colors.backgroundPutty};
    
    :focus {
    	box-shadow: unset;
    }
  }
  
  .ant-slider-handle.ant-tooltip-open {
  	border-color: ${({theme}) => theme.colors.backgroundPutty};
  }

  @media (min-width: ${(props) => props.theme.mediaQueryConstants.phoneTiny + 1}px) {
  	min-width: 215px;
	}
`;

export const ArrowLeft = styled(SvgIcon)`
	margin-top: 10px;

	path {
		fill: ${({theme}) => theme.colors.fallow};
	}
	
	${({disabled}: {disabled: boolean}) => disabled && css`
		pointer-events: none;
		
		path {
			fill: ${({theme}) => theme.colors.silver};
		}
	`}
`;

export const ArrowRight = styled(ArrowLeft)`
	transform: matrix(-1, 0, 0, 1, 0, 0);
`;
